import styled from 'styled-components';

import * as Common from '../../../../Styles';

const Theme = Common.Theme;

export const Instructions = styled(Common.FlexRow)`
	margin: 0.5rem auto;
	text-align:center;
`;

export const RulesHeading = styled(Common.FlexRow)`
justify-content: center;
text-align: center;
padding-top: 0.5rem;
`;

export const Rules = styled(Common.FlexRow)`
	align-self:center;
	padding-bottom: 0.5rem;
`;

export const RuleList = styled.ul`
	list-style: circle;
`;